<div class="container" loading-spin [isLoading]="isPageLoading" [loadingSize]="'big'" [loadingLevel]="110">
    <research-screen *ngIf="!isPageLoading" [config]="config"></research-screen>
</div>